import { render } from "./AssignAssessors.vue?vue&type=template&id=e77ac57c&scoped=true"
import script from "./AssignAssessors.vue?vue&type=script&lang=js"
export * from "./AssignAssessors.vue?vue&type=script&lang=js"

import "./AssignAssessors.vue?vue&type=style&index=0&id=e77ac57c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e77ac57c"]])

export default __exports__